module.exports = __webpack_public_path__ + "img/easy_explanation.e606e2f9.png";